import * as Yup from 'yup';
import { passwordComplexityRegex } from '../../common/constants/regex';
import { ExhibitDto } from '../exhibits/exhibits.dtos';

const newDate = new Date();
newDate.setMonth(newDate.getMonth() + 3);

export interface GroupVisitDto {
    id?: string,
    groupName: string,
    contact: string,
    email: string,
    phone: string,
    groupSize: number,
    reservationId: string,
    leaderName: string,
    url: string,
    expirationDate: Date,
    isActive: boolean,
    images?: ImageDto[],
    scans?: GroupScansDto[],
    isDuplicate: boolean
}

export interface ImageDto {
    id?: string,
    imageFileName: string,
    mimeType: string
}

export interface GroupScansDto {
    groupVisitId: string,
    exhibitId: string,
    exhibit: ExhibitDto,
}

export const groupVisitInit: GroupVisitDto = {
    id: '',
    groupName: '',
    contact: '',
    email: '',
    phone: '',
    groupSize: 0,
    reservationId: '',
    leaderName: '',
    url: '',
    expirationDate: newDate,
    isActive: true,
    images: [],
    isDuplicate: false
}

export const imageInit: ImageDto = {
    id: '',
    imageFileName: '',
    mimeType: ''
}

export const groupVisitValidationSchema = Yup.object().shape({
    groupName: Yup.string().required("Please enter a group name"),
    contact: Yup.string().required("Please enter a contact name"),
    email: Yup.string().email("Invalid email address").required("Please enter a contact email"),
    phone: Yup.string().required("Please enter a contact phone number"),
    groupSize: Yup.number().moreThan(0, "Group size must be greater than 0").required(
        'Please enter the group size.'
      ),
});

export interface GroupVisitResetPasswordDto {
    groupVisitId?: string,
    token?: string,
    password?: string,
    confirmPassword?: string,
  }
  
  export const resetPasswordInit: GroupVisitResetPasswordDto = { groupVisitId: '', token: '', password: '', confirmPassword: '', };

  
export const resetPasswordValidationSchema = Yup.object({
    password: Yup.string()
      .min(12, 'Password must be 12 characters or longer.')
      .max(128, 'New password must be 128 characters or less.')
      .matches(
        passwordComplexityRegex,
        'Password must contain at least 1 uppercase character, 1 lowercase character, 1 number, 1 special character and be at least 12 characters.'
      )
      .required('Please enter your new password.'),
    confirmPassword: Yup.string()
      .oneOf(
        [Yup.ref('password')],
        'New password and confirm password must match.'
      )
      .required('Please enter your new password.'),
  })